import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { risapi } from '../api/risapi';

import {AuthContext} from './AuthContext'; // Assuming you have an AuthContext

const LoginPage = () => {
  const [phone_number, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const { user,login } = useContext(AuthContext); // Get the login function from context

  const navigate = useNavigate();
  
  if(user){
   navigate('/docs/search-documentations');
  }
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await risapi.post('/api/login', { // Replace with your API endpoint
        phone_number,
        password,
      });

      if (response.status === 200) {
        // Login successful
        console.log("login success",response);
        console.log(response.data);
        const { access_token } = response.data; // Assuming the API returns a token
        login(access_token); // Call the login function from context to store the token
        navigate('/docs/search-documentations'); // Redirect to the home page
      }
    } catch (error) {
      // Handle errors (e.g., invalid credentials, network errors)
      console.error('Error logging in:', error);
      // Display error messages to the user
    }
  };

  return (
   <>
<div className='sign-in-bg'>
<div className="app-wrapper d-block">
  <div className>
    {/* Body main section starts */}
    <div className="container main-container">
      <div className="row main-content-box">
        <div className="col-lg-7 image-content-box d-none d-lg-block">
          <div className="form-container">
            <div className="signup-content mt-4">
              <span>
               <img alt className="img-fluid" style={{maxWidth:"400px"}} src={process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_LOGO_PATH} />
              </span>
            </div>
            <div className="signup-bg-img">
              <img alt className="img-fluid" src="../assets/images/login/01.png" />
            </div>
          </div>
        </div>
        <div className="col-lg-5 form-content-box">
          <div className="form-container ">
            <form onSubmit={handleSubmit}  className="app-form">
              <div className="row">
                <div className="col-12">
                  <div className="mb-5 text-center text-lg-start">
                    <h2 className="text-white f-w-600">Welcome To <span className="text-dark">{process.env.REACT_APP_NAME}!</span> </h2>
                    <p className="f-s-16 mt-2">Sign in view docs</p>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating mb-3">
                    <input className="form-control" value={phone_number} onChange={(event)=> setPhoneNumber(event.target.value)} placeholder="Enter Login Phone Number" type="text" />
                    <label htmlFor="UserName">Login Phone Number</label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating mb-3">
                    <input className="form-control"  value={password} onChange={(event)=> setPassword(event.target.value)} placeholder="Enter Password" type="text" />
                    <label htmlFor="floatingInput">Password</label>
                  </div>
                  <div className="text-end ">
                    {/* <a className="text-dark f-w-500 text-decoration-underline" href="forgot_password.html">Forgot password</a> */}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-check d-flex align-items-center gap-2 mb-3">
                    <input className="form-check-input w-25 h-25" id="checkDefault" type="checkbox" defaultValue />
                    <label className="form-check-label text-white mt-2 f-s-16 text-dark" htmlFor="checkDefault">
                      Remember me
                    </label>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <button  type='submit' className="btn btn-primary btn-lg w-100">Sign In</button>
                </div>
                {/* <div className="col-12 mt-4">
                  <div className="text-center text-lg-start f-w-500">
                    Don't Have Your Account yet?
                    <a className="text-white-800 text-decoration-underline" href="sign_up.html">Sign up</a>
                  </div>
                </div> */}
                {/* <div className="app-divider-v light justify-content-center py-lg-5 py-3">
                  <p>OR</p>
                </div> */}
                {/* <div className="col-12">
                  <div className="d-flex gap-3 justify-content-center text-center">
                    <button className="btn btn-light-white  icon-btn w-45 h-45 b-r-15 " type="button">
                      <i className="ph-bold ph-facebook-logo f-s-20" />
                    </button>
                    <button className="btn btn-light-white  icon-btn w-45 h-45 b-r-15 " type="button">
                      <i className="ph-bold  ph-google-logo f-s-20" />
                    </button>
                    <button className="btn btn-light-white  icon-btn w-45 h-45 b-r-15 " type="button">
                      <i className="ph-bold  ph-twitter-logo f-s-20" />
                    </button>
                  </div>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    {/* Body main section ends */}
  </div>
</div>
</div>


   </>
  );
};

export default LoginPage;